import { render, staticRenderFns } from "./CreditCard.vue?vue&type=template&id=48be57d0&scoped=true"
import script from "./CreditCard.vue?vue&type=script&lang=js"
export * from "./CreditCard.vue?vue&type=script&lang=js"
import style0 from "./CreditCard.vue?vue&type=style&index=0&id=48be57d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be57d0",
  null
  
)

/* custom blocks */
import block0 from "./CreditCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports